import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import { apiErrorMessage } from "../../utils/apiErrorMessage";
import Section from "./Section";

// O corpo de um cartao cuja resposta vem de uma rota pedida a parte: o esqueleto enquanto ela vem, ou o erro
// com "Tentar de novo" como no Conteudo. Uma 404 e a rota que o backend ainda nao tem (ou ja nao tem, num
// rollback): o "Not Found" do FastAPI e em ingles, por isso fica a frase traduzida, como no Exportar. Os
// outros erros mostram o `detail` do backend, quando o houver.
export const LoadingOrError = ({ error, onRetry }) => {
  const { translate } = useLanguage();
  return error ? (
    <div role="alert" className="text-sm space-y-2" style={{ color: "var(--color-error-text)" }}>
      <p>{error.response?.status === 404 ? translate("analyticsLoadFailed") : apiErrorMessage(error, translate("analyticsLoadFailed"))}</p>
      <button
        type="button"
        onClick={onRetry}
        className="px-3 py-1.5 text-sm rounded-lg border"
        style={{ borderColor: "var(--color-border)", backgroundColor: "var(--color-surface)", color: "var(--color-text-primary)" }}
      >
        {translate("analyticsRetry")}
      </button>
    </div>
  ) : (
    <div aria-busy="true" className="relative">
      <span className="sr-only">{translate("loading")}</span>
      <div className="rounded-xl animate-pulse h-40" style={{ backgroundColor: "var(--color-surface-raised)" }} />
    </div>
  );
};

// As secoes que vem de /analytics/assistant (D12): a secao desenha-se sempre com o seu titulo, e o corpo e o
// `LoadingOrError` ate a resposta chegar.
export const ActivityPlaceholder = ({ title, error, onRetry }) => (
  <Section title={title} className="grid gap-4">
    <LoadingOrError error={error} onRetry={onRetry} />
  </Section>
);
